import PropTypes from 'prop-types'
import {
  ThemeProvider as ThemeProviderV4
} from '@material-ui/core/styles'
import {
  StyledEngineProvider,
  ThemeProvider as ThemeProviderV5
} from '@mui/material/styles'
import { themeV4, themeV5 } from './muiTheme'

const AppThemeProvider = ({ children }) => (
  <StyledEngineProvider injectFirst>
    <ThemeProviderV4 theme={themeV4}>
      <ThemeProviderV5 theme={themeV5}>
        {children}
      </ThemeProviderV5>
    </ThemeProviderV4>
  </StyledEngineProvider>
)

AppThemeProvider.propTypes = {
  children: PropTypes.node.isRequired
}

export default AppThemeProvider
